import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CountryCode } from '~/enums';
import {
  defaultLanguagePerMarket,
  getLanguageFromLocalStorage,
  getMarketFromLocalStorage,
  languageIsValidForMarket,
} from '~/helpers/market.helper';
import { Language } from '../types/sharedTypes';
import { getMarketBasedOnHostname } from '~/helpers/utils';
import { IntlState } from '~/Interfaces';

const initialMarket = getMarketFromLocalStorage() ?? getMarketBasedOnHostname();

let initialLanguage;
const localStorageLanguage = getLanguageFromLocalStorage();

if (initialMarket) {
  if (
    localStorageLanguage &&
    languageIsValidForMarket(localStorageLanguage, initialMarket)
  ) {
    initialLanguage = localStorageLanguage;
  } else {
    initialLanguage = defaultLanguagePerMarket[initialMarket];
  }
}

export const intlInitialState: IntlState = Object.freeze({
  market: initialMarket ?? CountryCode.SE,
  marketIsSet: !!initialMarket,
  language: initialLanguage ?? Language.English,
  languageIsSet: !!initialLanguage,
});
window.__QRED_MARKET__ = initialMarket ?? CountryCode.SE;

const intlSlice = createSlice({
  name: 'intl',
  initialState: intlInitialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.language = action.payload;
      state.languageIsSet = true;
      localStorage.setItem('qredLanguage', action.payload);
    },
    setMarket: (state, action: PayloadAction<CountryCode>) => {
      state.market = action.payload;
      state.marketIsSet = true;
      localStorage.setItem('qredMarket', action.payload);
      window.__QRED_MARKET__ = action.payload.toUpperCase();
    },
  },
});

export const { setLanguage, setMarket } = intlSlice.actions;

export default intlSlice.reducer;

export const defaultLanguageToMarket = (market: CountryCode) => {
  const language = defaultLanguagePerMarket[market];

  if (!language) {
    throw new Error('Invalid market');
  }

  return setLanguage(language);
};
